import React from "react";
import { useEffect } from "react";
import PinjamWarkah from "../../components/Pinjam/DaftarPinjamWarkah";

const PeminjamanWarkah = () => {
  useEffect(() => {
    document.title = "Si TASIK - Peminjaman";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <PinjamWarkah/>
    </div>
  );
};

export default PeminjamanWarkah;
